export const recipientMiscDocConstants = {
    // Add and editing app
    SAVING_RECIPIENT_MISC_DOC_REQUEST: 'SAVING_RECIPIENT_MISC_DOC_REQUEST',
    SAVING_RECIPIENT_MISC_DOC_SUCCESS: 'SAVING_RECIPIENT_MISC_DOC_SUCCESS',
    SAVING_RECIPIENT_MISC_DOC_FAILURE: 'SAVING_RECIPIENT_MISC_DOC_FAILURE',

    // Loading apps
    LOAD_RECIPIENT_MISC_DOCS_REQUEST: 'LOAD_RECIPIENT_MISC_DOCS_REQUEST',
    LOAD_RECIPIENT_MISC_DOCS_SUCCESS: 'LOAD_RECIPIENT_MISC_DOCS_SUCCESS',
    LOAD_RECIPIENT_MISC_DOCS_FAILURE: 'LOAD_RECIPIENT_MISC_DOCS_FAILURE',

    // Delete app
    DELETE_RECIPIENT_MISC_DOC_REQUEST: 'DELETE_RECIPIENT_MISC_DOC_REQUEST',
    DELETE_RECIPIENT_MISC_DOC_SUCCESS: 'DELETE_RECIPIENT_MISC_DOC_SUCCESS',
    DELETE_RECIPIENT_MISC_DOC_FAILURE: 'DELETE_RECIPIENT_MISC_DOC_FAILURE',
}


// WEBPACK FOOTER //
// ./src/redux/constants/recipientMiscDoc.constants.js